export const getProperties = {
  get TermsAndConditionsUrl() {
    return 'https://www.telstra.com.au/customer-terms/business-government'
  },

  get PrivacyPolicyUrl() {
    return 'https://www.telstra.com.au/privacy'
  },
  get MNPFAQUrl() {
    return '/app/support/faq#Monitoring%20and%20performance%20-%20Australian%20customers_Network%20services'
  },
  get MDUMFAQUrl() {
    return '/app/support/faq#Monitoring%20and%20performance%20-%20Australian%20customers_Mobile%20data%20usage'
  },
  get contactNumber() {
    return '1300 365 657'
  },
  get email() {
    return 'telstra.change.management@team.telstra.com'
  },
}
